<template>
  <div class="common-home-content" v-show="show">
    <ul class="prescriptions-ul clearfix">
      <li
        class="fl prescription"
        v-for="(child, index) in prescription.content"
        :key="index"
        v-show="status_show"
      >
        <div class="content" :class="child.usage?'has-usage':''">
          <button class="delete" @click="handleDelete(index)"></button>
          <div @click="handleSelectUsage(child, index)">
            <p class="name">{{child.name}}</p>
            <p class="usage" v-if="child.usage">{{child.usage}}</p>
          </div>
          <input type="number" v-model="child.quantity" />
          <span class="unit">{{companyFormat(child.unit)}}</span>
        </div>
      </li>
      <li
        class="fl add"
        :class="status_show?'':'actived'"
      >
        <div class="content">
          <span class="icon"></span>
          <input type="text" :placeholder="placeholder" v-model="keyword" @input="handleInput" @focus="handleFocus" @blur="handleBlur" />
        </div>
      </li>
    </ul>
    <div class="search-result-fixed" v-show="result_show && keyword">
      <ul class="search-result-ul clearfix">
        <li
          class="fl"
          v-for="(child, index) in medicines"
          :key="index"
          @click="handleSeleteMedicine(child)"
        >{{child.name}}</li>
      </ul>
    </div>
    <van-popup v-model="delete_popup_show" :close-on-click-overlay="false">
      <div class="delete-popup-window">
        <p class="title">删除药材</p>
        <p class="prompt">确认删除当前药材吗？</p>
        <div class="btns clearfix">
          <button class="fl left" @click="handleClosePopup">取消</button>
          <button class="fr right" @click="handleConfirmDelete">删除</button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="save_popup_show" :close-on-click-overlay="false">
      <div class="save-popup-window">
        <p class="title">保存常用方</p>
        <van-field class="prescription-name" v-model="prescription_name" placeholder="输入常用方名称" />
        <div class="btns clearfix">
          <button class="fl left" @click="handleClosePopup">取消</button>
          <button class="fr right" @click="handleConfirmSave">确认</button>
        </div>
      </div>
    </van-popup>
    <van-popup class="usages-popup-window" v-model="usages_popup_show" position="bottom" closeable :close-on-click-overlay="false">
      <ul class="usages-ul">
        <li class="actived">{{usage_title}}</li>
        <li
          v-for="(child, index) in usages"
          :key="index"
          @click="handleSaveUsage(child)"
        >{{child}}</li>
        <li @click="handleSaveUsage(false)">无</li>
      </ul>
    </van-popup>
    <van-popup v-model="chaoliangShow" :close-on-click-overlay="false">
      <div class="save-popup-window">
        <p class="title">超量提示</p>
        <p style="color: #666">以下药材用量已超过药典建议用量:</p>
        <p style="color: #AC4B38">{{chaoliangStr}}</p>
        <p>确认后,药房将根据实际情况决定是否接单,确认处方?</p>
        <div class="btns clearfix">
          <button class="fl left" @click="chaoliangCancel">取消</button>
          <button class="fr right" @click="chaoliangOK">确认</button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="peiwuShow" :close-on-click-overlay="false">
          <div class="save-popup-window">
            <p class="title">配伍禁忌</p>
            <view v-for="(item,index) in peiwuData" :key="index">
              <p style="color: #666">以下药材为配伍禁忌:{{item.role}}</p>
              <p style="color: #AC4B38">{{item.name}}{{item.taboo_name}}</p>
            </view>
            <p>确认后,药房将根据实际情况决定是否接单,确认处方?</p>
            <div class="btns clearfix">
              <button class="fl left" @click="peiwuCancel">取消</button>
              <button class="fr right" @click="peiwuOK">确认</button>
            </div>
          </div>
        </van-popup>
    <van-popup v-model="jianyiShow" :close-on-click-overlay="false">
          <div class="save-popup-window">
            <p class="title">用法建议</p>
            <view v-for="(item,index) in jianyiData" :key="index">
              <p style="color: #666">{{item.name}}建议 <span style="color: #AC4B38">{{item.usages}}</span></p>
            </view>
            <p>是否采纳?</p>
            <div class="btns clearfix">
              <button class="fl left" @click="jianyiCancel">取消</button>
              <button class="fr right" @click="jianyiOK">确认</button>
            </div>
          </div>
        </van-popup>

  </div>
</template>
<script>
import $ from "jquery";
import { _ } from "vue-underscore";
import http from "../../util/dorisApiConfig";
import { addBridgeForAndroidWebView } from "sdbridge-android";
import VConsole from 'vconsole'
export default {
  data() {
    return {
      show: false,
      chaoliangShow: false,
      chaoliangStr: "",
      peiwuShow: false,
      peiwuData: [],
      jianyiData: [],
      jianyiShow: false,
      doctor_id: 1,
      token: "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoxMDIwMzc0NiwiZXhwX3RpbWUiOjE3MDE3NTczOTR9.0tURec7vNQ3g2YBAnGaD5Tfztt-xQLASgfqnoSgxgAw",
      status_show: true,
      placeholder: "点击添加药材",
      delete_popup_show: false,
      save_popup_show: false,
      usages_popup_show: false,
      select_prescription_index: 0,
      prescription_name: "",
      prescription: {
        name: "",
        content: []
      },
      result_show: false,
      is_select: false,
      medicines: [],
      keyword: "",
      usage_title: "",
      usages: ["先煎", "后下", "焗服", "冲服", "包煎", "烊化兑服", "另炖"],
      isApp: "",
      platform_type:1,
    };
  },
  created() {
    let bridge = window.WebViewJavascriptBridge;
    this.isApp = this.$appUtils.isApp();
    if (this.isApp == "IOS") {
      bridge.callHandler("showTrBtn", { name: "保存" }, response => {});
      bridge.callHandler("getUserInfo", "", response => {
        console.log(response);
        this.token = response.token;
        this.platform_type = response.platform_type;
        this.doctor_id = response.doctor_id;
      });
      bridge.registerHandler("handelSave", (data, responseCallback) => {
        this.handelSave();
      });
    } else if (this.isApp == "android") {
      this.$appUtils.showAppTrBtn({ name: "保存" });
      var user_info = this.$appUtils.appData();
      if (user_info) {
        this.token = user_info.token;
        this.platform_type = user_info.platform_type;
        this.doctor_id = user_info.doctor_id;
      }

    }else {

    }
    if (localStorage.getItem("local_prescription")) {
      this.prescription = JSON.parse(
        localStorage.getItem("local_prescription")
      );
    }
    this.show = true;
    window.appTrBtnClick = () => this.handelSave();
    window.appBack = () => this.pageback();
  },
  methods: {
    companyFormat(str) {
      if (str == "克") {
        return "g";
      } else {
        return str;
      }
    },
    handleDelete(index) {
      this.select_prescription_index = index;
      this.delete_popup_show = true;
    },
    handleClosePopup() {
      this.delete_popup_show = false;
      this.save_popup_show = false;
    },
    handleConfirmDelete() {
      this.prescription.content.splice(this.select_prescription_index, 1);
      this.delete_popup_show = false;
    },
    handleSelectUsage(item, index) {
      this.usage_title = item["name"];
      this.select_prescription_index = index;
      this.usages_popup_show = true;
    },
    handleSaveUsage(name) {
      if (name) {
        this.prescription.content[this.select_prescription_index][
          "usage"
        ] = name;
      } else {
        this.prescription.content[this.select_prescription_index]["usage"] = "";
      }
      this.usages_popup_show = false;
    },
    throttleFun: _.throttle(
      function() {
        let that = this;
        let params = {};
        if (that.keyword) {
          params["keyword"] = that.keyword;
        }
        http
          .get("/drugs/" + that.doctor_id + "/search?platform_type="+that.platform_type, {
            params: params,
            headers: {
              Authorization: that.token
            }
          })
          .then(function(res) {
            if (res.data.status_code == 200) {
              that.medicines = res.data.data.medicines.slice(0, 20);
            }
          });
      },
      100,
      { leading: false }
    ),
    handleInput() {
      this.throttleFun();
    },
    handleFocus() {
      this.placeholder = "输入中药名";
      this.status_show = false;
      this.result_show = true;
    },
    handleBlur(bol) {
      let that = this;
      setTimeout(function() {
        that.keyword = "";
        that.medicines = [];
        that.placeholder = "点击添加药材";
        that.status_show = true;
        that.result_show = false;
        if (that.is_select) {
          setTimeout(function() {
            $(".prescriptions-ul li")
              .eq(that.prescription.content.length - 1)
              .find("input")
              .focus();
            that.is_select = false;
          }, 10);
        }
      }, 150);
    },
    handleSeleteMedicine(item) {
      let checks = _.filter(this.prescription.content, function(obj) {
        return obj["name"] == item["name"];
      });
      if (checks.length > 0) {
        this.$toast("药材已添加！");
      } else {
        this.prescription.content.push({
          name: item["name"],
          quantity: 1,
          unit: item["unit"]
        });
        this.is_select = true;
      }
    },
    handelSave() {
      if (this.prescription.content.length == 0) {
        this.$toast("请添加药材！");
      } else {
        for (let i = 0; i < this.prescription.content.length; i++) {
          var objReplace = JSON.stringify(this.prescription.content); //首先给对象转换成字符串
          var newObjString = objReplace.replace(/quantity/g, "count"); //使用正则匹配需要替换的字段名字，替换成需要的字段名
          var newObj = JSON.parse(newObjString);
          this.prescription.content = newObj;
        }
        let params = {
          content: JSON.stringify(this.prescription.content),
          type: "2"
        };
        console.log(JSON.stringify(params));
        http.post("drugs/check_drug?platform_type="+this.platform_type, params).then(res => {
          console.log(JSON.stringify(res));
          if (res.data.status_code == 200) {
            if (res.data.data.type == 1) {
              this.prescription_name = this.prescription.name;
              this.save_popup_show = true;
            } else if (res.data.data.type == -3) {
              this.chaoliangShow = true;
              let str = [];
              for (let i = 0; i < res.data.data.info.length; i++) {
                str.push(
                  res.data.data.info[i].name + res.data.data.info[i].max_count
                );
              }
              this.chaoliangStr = str.toString();
            } else if (res.data.data.type == -2) {
              this.peiwuShow = true;
              this.peiwuData = res.data.data.info;
            } else if (res.data.data.type == -4) {
              this.jianyiShow = true;
              this.jianyiData = res.data.data.info;
            }
          }
        });
      }
    },
    chaoliangOK() {
      this.prescription_name = this.prescription.name;
      this.save_popup_show = true;
      this.chaoliangShow = false;
    },
    chaoliangCancel() {
      this.chaoliangShow = false;
    },
    peiwuOK() {
      this.prescription_name = this.prescription.name;
      this.save_popup_show = true;
      this.peiwuShow = false;
    },
    peiwuCancel() {
      this.peiwuShow = false;
    },
    jianyiCancel() {
      this.prescription_name = this.prescription.name;
      this.save_popup_show = true;
      this.jianyiShow = false;
    },
    jianyiOK() {
      this.prescription_name = this.prescription.name;
      this.save_popup_show = true;
      this.jianyiShow = false;
    },

    handleConfirmSave() {
      let that = this;
      if (that.prescription_name) {
        for (let i = 0; i < this.prescription.content.length; i++) {
          var objReplace = JSON.stringify(this.prescription.content); //首先给对象转换成字符串
          var newObjString = objReplace.replace(/count/g, "quantity"); //使用正则匹配需要替换的字段名字，替换成需要的字段名
          var newObj = JSON.parse(newObjString); //最后转换成对象就ok啦
          this.prescription.content = newObj;
        }
        let params = {
          name: that.prescription_name,
          content: JSON.stringify(that.prescription.content),
          platform_type:that.platform_type
        };
        if (that.prescription.prescription_id) {
          params["prescription_id"] = that.prescription.prescription_id;
          http
            .put("/drugs/" + that.doctor_id + "/self_prescriptions", params, {
              headers: { Authorization: that.token }
            })
            .then(function(res) {
              if (res.data.status_code == 200) {
                that.pageback();
              }
            });
        } else {
          http
            .post("/drugs/" + that.doctor_id + "/self_prescriptions", params, {
              headers: { Authorization: that.token }
            })
            .then(function(res) {
              if (res.data.status_code == 200) {
                that.pageback();
              }
            });
        }
      } else {
        that.$toast("请输入常用方名称！");
      }
    },
    pageback() {
      window.history.back();
      return true;
    }
  }
};
</script>
<style lang="scss" scoped>
.common-home-content {
  padding-top: 10px;
  padding-bottom: 58px;
  height: 100%;
  box-sizing: border-box;
}
.prescriptions-ul {
  width: 100%;
  box-sizing: border-box;
  padding: 0 7px;
  & > li {
    margin-top: 10px;
    height: 50px;
    width: 50%;
    box-sizing: border-box;
    padding: 0 8px;
    .content {
      width: 100%;
      box-sizing: border-box;
      background: #ffffff;
      box-shadow: 0px 2px 5px 1px rgba(35, 24, 21, 0.15);
      border-radius: 5px;
      position: relative;
    }
  }
  .prescription {
    .content {
      padding: 10px 65px 10px 30px;
      .delete {
        display: block;
        width: 14px;
        height: 14px;
        background: url("../../assets/images/prescription/delete.png") no-repeat;
        background: none\9;
        filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../../assets/images/prescription/delete.png',sizingMethod='scale');
        -webkit-background-size: 14px 14px;
        -moz-background-size: 14px 14px;
        background-size: 14px 14px;
        margin: auto;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 10px;
      }
      .name {
        line-height: 30px;
        font-size: 14px;
        font-family: PingFang-SC-Medium;
        font-weight: 500;
        color: #333333;
        white-space: nowrap;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      input {
        width: 40px;
        padding: 0;
        box-sizing: border-box;
        height: 34px;
        line-height: 34px;
        font-size: 14px;
        font-family: PingFang-SC-Medium;
        font-weight: 500;
        color: #333333;
        border: 0;
        border-radius: 0;
        text-align: center;
        border-bottom: 1px solid #da8373;
        background-color: transparent;
        margin: auto;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 24px;
      }
      .unit {
        display: block;
        height: 34px;
        line-height: 34px;
        font-size: 14px;
        font-family: PingFang-SC-Medium;
        font-weight: 500;
        color: #666666;
        margin: auto;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 10px;
      }
    }
    .has-usage {
      .name {
        line-height: 14px;
      }
      .usage {
        margin-top: 4px;
        line-height: 12px;
        font-size: 12px;
        font-family: PingFang-SC-Medium;
        font-weight: 500;
        color: #ac4b38;
        white-space: nowrap;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .add {
    .content {
      padding-left: 53px;
      padding-right: 10px;
      input {
        width: 100%;
        box-sizing: border-box;
        padding: 0;
        border: 0;
        line-height: 50px;
        font-size: 14px;
        font-family: PingFang-SC-Medium;
        font-weight: 500;
        color: #333333;
        background-color: transparent;
      }
    }
    .icon {
      display: block;
      width: 17px;
      height: 16px;
      background: url("../../assets/images/prescription/add.png") no-repeat;
      background: none\9;
      filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../../assets/images/prescription/add.png',sizingMethod='scale');
      -webkit-background-size: 17px 16px;
      -moz-background-size: 17px 16px;
      background-size: 17px 16px;
      margin: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 26px;
    }
  }
  .actived {
    .content {
      padding-left: 10px;
    }
    .icon {
      display: none;
    }
  }
}
.search-result-fixed {
  width: 100%;
  background: #f2f2f2;
  overflow-x: scroll;
  position: fixed;
  left: 0;
  bottom: 0;
  .search-result-ul {
    width: max-content;
    & > li {
      display: inline-block;
      line-height: 48px;
      padding: 0 15px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #000000;
    }
  }
}
.delete-popup-window {
  width: 300px;
  box-sizing: border-box;
  padding: 25px 24px;
  .title {
    line-height: 16px;
    font-size: 16px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    text-align: center;
    color: rgba(52, 52, 52, 1);
  }
  .prompt {
    margin-top: 34px;
    line-height: 16px;
    font-size: 16px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    text-align: center;
    color: rgba(52, 52, 52, 1);
  }
  .btns {
    margin-top: 42px;
    width: 100%;
    box-sizing: border-box;
    .left {
      width: 120px;
      line-height: 30px;
      font-size: 15px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: rgba(172, 76, 56, 1);
      text-align: center;
      border: 1px solid rgba(172, 76, 56, 1);
      border-radius: 4px;
    }
    .right {
      width: 120px;
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: #fff;
      text-align: center;
      background-color: rgba(172, 76, 56, 1);
      border-radius: 4px;
    }
  }
}

.save-popup-window {
  width: 300px;
  box-sizing: border-box;
  padding: 20px 25px 27px 25px;
  .title {
    line-height: 16px;
    font-size: 16px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    text-align: center;
    color: rgba(52, 52, 52, 1);
  }
  .prescription-name {
    margin-top: 20px;
    width: 100%;
    box-sizing: border-box;
    border: 0;
    padding-left: 10px;
    padding-right: 10px;
    background: #ffffff;
    box-shadow: 0px 2px 5px 1px rgba(35, 24, 21, 0.15);
    border-radius: 5px;
  }
  .btns {
    margin-top: 26px;
    width: 100%;
    box-sizing: border-box;
    .left {
      width: 120px;
      line-height: 30px;
      font-size: 15px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: rgba(172, 76, 56, 1);
      text-align: center;
      border: 1px solid rgba(172, 76, 56, 1);
      border-radius: 4px;
    }
    .right {
      width: 120px;
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: #fff;
      text-align: center;
      background-color: rgba(172, 76, 56, 1);
      border-radius: 4px;
    }
  }
}
.usages-popup-window {
  height: 460px;
  border-radius: 10px 10px 0 0 !important;
  .usages-ul {
    width: 100%;
    box-sizing: border-box;
    padding: 0 15px;
    & > li {
      width: 100%;
      box-sizing: border-box;
      line-height: 50px;
      font-size: 16px;
      font-family: PingFang-SC-Bold;
      font-weight: 500;
      color: #333333;
      text-align: center;
      border-bottom: 1px solid #e6e6e6;
    }
    .actived {
      font-family: PingFang-SC-Medium;
      font-weight: bold;
      color: #ac4b38;
    }
    & > li:last-child {
      border-bottom: 0;
    }
  }
}
.van-popup {
  border-radius: 10px;
}
</style>
<style>
.usages-popup-window .van-icon {
  font-size: 16px;
  color: #999999;
}
</style>>



// WEBPACK FOOTER //
// src/components/prescription/editPrescription.vue